import { css } from "@emotion/core";
import styled from "@emotion/styled";
import { Link } from "react-router-dom";
import { DropDown } from "../DropDown.styles";
import { resetFormElementStyles, at } from "../../styles/utils";

import {
  breakpoints,
  main_nav_height,
  spacing,
  fonts,
} from "../../styles/vars";

export const MainNav = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: ${spacing.mobile};
  background: rgba(0, 0, 0, 0.8);
  position: relative;
  z-index: 10;
  ${at(breakpoints.desktop)} {
    background: transparent;
    padding: ${spacing.mobile} ${spacing.desktop};
  }
`;

export const ContentNav = styled.div`
  z-index: 9;
  width: 100%;
  height: ${({ opened }) =>
    opened ? `calc(100vh - ${main_nav_height.mobile})` : "auto"};
  padding: 0 ${spacing.mobile};
  overflow: scroll;
  background: ${({ opened }) =>
    opened ? "rgb(0, 0, 0, 0.85)" : "rgb(0, 0, 0, 0.7)"};

  ${at(breakpoints.laptop)} {
    background: transparent;
    height: auto;
  }
  ${at(breakpoints.desktop)} {
    padding: 0 ${spacing.desktop};
  }
`;

const linkStyles = css`
  display: block;
`;

export const ParentLink = styled(Link)`
  ${linkStyles};
`;

export const ChildLink = styled(Link)`
  ${linkStyles};
`;

export const LangLink = styled(Link)``;

const nav_item_styles = css`
  width: 100%;
  margin-bottom: 1em;
  font-family: ${fonts.bold};
  font-size: 1.2em;
  text-transform: capitalize;
  color: rgba(255, 255, 255, 0.8);
  outline: none;
  cursor: pointer;
  transition: opacity 0.2s linear;

  display: flex;
  align-items: center;
  text-transform: capitalize;

  &:hover {
    opacity: 1;
  }
`;

export const NavCustomLink = styled(Link)`
  ${nav_item_styles}
  position: relative;
  display: block;
  text-decoration: none;
`;

export const NavButton = styled.button`
  ${resetFormElementStyles}
  ${nav_item_styles}
  &.lang-button {
    margin: 0;
  }
  [lang="ar"] & {
    &.lang-button {
    }
  }
`;

export const NavIcon = styled.div`
  height: 34px;
  margin: 0 ${spacing.mobile} 0 0;
  [lang="ar"] & {
    margin: 0 0 0 ${spacing.mobile};
  }
  svg {
    width: auto;
    height: 100%;
    margin: 0 auto;
  }
  ${at(breakpoints.laptop)} {
    margin: 0 ${spacing.desktop} 0 0;
    [lang="ar"] & {
      margin: 0 0 0 ${spacing.desktop};
    }
  }
  ${at(breakpoints.desktop)} {
    height: 48px;
  }
`;

export const MapMobileNav = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  .menu-icon {
    font-size: 32px;
  }
`;

export const MobileNavToggle = styled.button`
  ${resetFormElementStyles}
  color: #FFF;
  font-size: 32px;
`;

export const ScreenNavWrapper = styled.nav`
  display: flex;
  a {
    opacity: 0.5;
    &.active {
      opacity: 1;
    }
  }
`;

const navigation_wrapper_styles = css`
  margin-bottom: 10px;
`;
export const LayersNavWrapepr = styled(DropDown)`
  ${navigation_wrapper_styles}

  ${at(breakpoints.laptop)} {
    margin: ${spacing.mobile} 0;
  }
  ${at(breakpoints.desktop)} {
    margin: ${spacing.desktop} 0;
  }
`;

export const ProjectsNavWrapper = styled(DropDown)`
  ${navigation_wrapper_styles}
`;

export const LanguageNavWrapper = styled(DropDown)``;

export const ChartsNavigationWrapper = styled(DropDown)`
  ${navigation_wrapper_styles}

  ${at(breakpoints.laptop)} {
    margin: ${spacing.mobile} 0;
  }
  ${at(breakpoints.desktop)} {
    margin: ${spacing.desktop} 0;
  }
`;
